<!--
  ~ /**
  ~   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
  ~   ~  * No part of this publication may be reproduced, distributed,
  ~   ~  * or transmitted in any form or by any means, including photocopying, recording,
  ~   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
  ~   ~  * except in the case of brief quotations embodied in critical
  ~   ~  * reviews and certain other noncommercial uses permitted by copyright law.
  ~   ~  * AUTHOR : bs
  ~   ~  * DATE : 29/04/2025 17:36
  ~ **/
  -->

<div class="wrapper">
  <inf-search-filter
    #searchFilterComponent
    [manager]="manager"
    [defaultTags]="true"
    (refresh)="listenSearchFilterRefresh()"
    [title]="displayTitle ? ('i18n.common.search' | translate) : ''"
    (deleteTag)="listenSearchFilterDeleteTag($event)"
  >
    <div class="wrapper-form">
      <div class="form" [style]="styleForContent">
        @if (manager) {
          <inf-form
            #form
            [entity]="manager.entity"
            [noPadding]="noPaddingForm"
            [model]="manager.model"
            (fieldChange)="listenFormFieldChange($event)"
          />
        }
      </div>
      @if (manager && manager.model) {
        <div class="content">
          <ng-content></ng-content>
        </div>
      }
    </div>
  </inf-search-filter>
</div>
